import styled from 'styled-components';

interface Props {
  isError?: boolean;
}

interface PropsReplicate {
  disabled: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  padding: 16px;
`;

export const SlotsWrapper = styled.div`
  display: grid;
  gap: 16px;
`;

export const ScheduleFieldItem = styled.div<Props>`
  margin-bottom: 24px;

  label {
    display: block;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: ${({ theme, isError }) =>
      isError ? theme.color.error2 : theme.color.grey600};
  }

  > span {
    display: block;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16.8px;
    color: ${({ theme }) => theme.color.grey500};
    margin-bottom: 16px;
  }
`;

export const SlotsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ReplicateButton = styled.div<PropsReplicate>`
  height: fit-content;
  margin-left: 32px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  color: ${({ theme, disabled }) =>
    disabled ? theme.color.grey400 : theme.color.blue800};
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.08px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  margin-bottom: 20px;
`;
